import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ac11978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "繁星CRM-平台端后台管理系统", -1))
const _hoisted_3 = { class: "head_img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "userName" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 1024 1024",
    width: "20px",
    height: "20px",
    xmlns: "http://www.w3.org/2000/svg",
    "data-v-78e17ca8": ""
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "m192 384 320 384 320-384z"
    })
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 1024 1024",
  width: "20px",
  height: "20px",
  xmlns: "http://www.w3.org/2000/svg",
  "data-v-78e17ca8": ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M352 159.872V230.4a352 352 0 1 0 320 0v-70.528A416.128 416.128 0 0 1 512 960a416 416 0 0 1-160-800.128z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M512 64q32 0 32 32v320q0 32-32 32t-32-32V96q0-32 32-32z"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pushText" }, "确定要退出登录吗？", -1))
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.userinfo.headPic ? _ctx.userinfo.headPic : '@/assets/Headerimg/headerimg.png',
        alt: ""
      }, null, 8, _hoisted_4),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.userinfo.userName), 1),
      _hoisted_6,
      _createElementVNode("div", {
        class: "logout",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.outLogin && _ctx.outLogin(...args)))
      }, _hoisted_8)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isloginout,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isloginout) = $event)),
      title: "是否退出登录",
      width: "380px",
      onClose: _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isloginout = false)),
            class: "cancelBtn"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.isPushSuccess
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    }, 8, ["modelValue", "onClose"])
  ]))
}